export const AMPLITUDE_BASE_URL = "https://api.amplitude.com/2/httpapi";
export const SLACK_URL_PLANS = "/slack-notificiacion-plans";
export const SLACK_URL_CHECKOUT = "/slack-notificiacion-checkout";
export const SLACK_URL_ERROR = "/slack-notification-error";
